import { styled } from '@mui/system';
import Paper from '@mui/material/Paper';
import MenuItem from '@mui/material/MenuItem';
import FONTS_FAMILY from '../../../theme/FontsFamily';

export const Container = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  cursor: 'pointer',
});

export const UserImage = styled('img')({
  borderRadius: '100%',
  height: '36px',
  width: '36px',
  objectFit: 'cover',
  border: '2px solid #BBC4F8',
  transition: 'border-color 0.2s ease',
  '&:hover': {
    borderColor: '#FFFFFF',
  }
});

export const StyledPaper = styled(Paper)({
  boxShadow: '0px 12px 32px rgba(3, 13, 57, 0.12)',
  marginTop: '8px',
  minWidth: '180px',
  borderRadius: '10px',
  border: '1px solid #E2E8F0',
  overflow: 'hidden',
});

export const StyledMenuItem = styled(MenuItem)({
  fontFamily: FONTS_FAMILY.bold.body,
  fontSize: '14px',
  fontWeight: '500',
  color: '#46464F',
  padding: '10px 20px',
  transition: 'all 0.15s ease',
  '&:hover': {
    backgroundColor: '#F0F3FF',
    color: '#192873',
  }
});
